import { Component, OnInit } from '@angular/core';
import { TelegramService } from "../../../../../services/telegram.service";
import { Question, QuestionClient } from 'src/app/services/apis/web-api-client';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {
  question: Question = new Question({ email: '', fio: '', phone: '', textQuestion: '' });

  constructor(
    private telegramService: TelegramService,
    private questionClient: QuestionClient,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
  }

  SendMessage() {
    if (this.question.fio.length > 0 && (this.question.email.length > 0 || this.question.phone.length > 0)) {
      this.questionClient.create(this.question).subscribe((response) => {
        this.question = new Question({ email: '', fio: '', phone: '', textQuestion: '' });
        this.toastrService.success('Ваш вопрос отправлен');
      }, error => this.toastrService.error('Что то пошло не так'))
    } else {
      this.toastrService.warning('Недостаточно данных, заполните поле ФИО, а также телефон или элктронный адрес', 'Внимание');
    }
    // this.telegramService.HelpChat(this.fio, this.phone, this.email);
  }
}
